import { z } from 'zod';

export const RESULTATS_PAR_TYPE = 20;

export const schemaRequeteRecherche = z.object({
  q: z.string().trim().min(2, 'Au moins deux caractères').max(200),
});

export const schemaResultatRecherche = z.object({
  courriers: z.array(
    z.object({ id: z.string().uuid(), numero: z.string(), sens: z.enum(['arrivee', 'depart']), objet: z.string(), correspondant: z.string(), etat: z.string(), rang: z.number() }),
  ),
  dossiers: z.array(
    z.object({ id: z.string().uuid(), numero: z.string().nullable(), demarche: z.string(), demandeur: z.string().nullable(), statut_usager: z.string(), etat: z.string(), rang: z.number() }),
  ),
  documents: z.array(
    z.object({ id: z.string().uuid(), titre: z.string(), type_document: z.string(), objet_type: z.string().nullable(), objet_id: z.string().nullable(), rang: z.number() }),
  ),
});
export type ResultatRecherche = z.infer<typeof schemaResultatRecherche>;
